import { format } from 'date-fns';
import {
  RequestPayloadData,
  RequestPayloadParsedData,
  RequestRequiredPayloadData,
} from './types';

const requestParser = (data: RequestPayloadData): RequestPayloadParsedData => {
  const payloadData: RequestRequiredPayloadData = {
    event_id: data.event_id,
    students: data.students,
  };
  return Object.assign(
    {},
    payloadData,
    data.dateStudyFrom &&
      data.dateStudyTo && {
        date_study_from: format(data.dateStudyFrom, 'YYYY-MM-DD'),
        date_study_to: format(data.dateStudyTo, 'YYYY-MM-DD'),
      },
  );
};

export default requestParser;



// WEBPACK FOOTER //
// ./src/services/orders/utils/requestParser.ts